import React, { useEffect, forwardRef } from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { mapScript } from "./mapScript";


const A4_HEIGHT_PX = 1200; // Height of an A4 page in pixels (approximately 297mm at 96 DPI)
const HEADER_HEIGHT_PX = 130; // Adjust according to your header height (50px + 20px margin-bottom)
const FOOTER_HEIGHT_PX = 60; // Adjust according to your footer height (70px + 20px margin-top)


const ExportView = forwardRef((props, ref) => {
  const { content, headerContent, headerHTML, footerHTML, contentHTML, preview, searchTags, boundingBoxCoord, setIsMapLoaded, isMapLoaded, formValuesCheckboxes, reportLoaded, isEditMode, onSaveChanges, formValues , layoutStyle, isScreenVisible, user, onRequestPageDelete} = props;
  let rootElement;


const themeFromStorage=localStorage.getItem("theme")
  useEffect(() => {
    const iframe = ref.current;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    


    const adjustIframeHeight = () => {
      if (iframeDoc.body.scrollHeight) {
        iframe.style.height = `${iframeDoc.body.scrollHeight}px`;
      }
    };

    const createNewPage = () => {
      const pageDiv = document.createElement('div');
      pageDiv.classList.add('export-page');

      const headerDiv = document.createElement('div');
      headerDiv.innerHTML = ReactDOMServer.renderToString(headerHTML);
      headerDiv.classList.add('export-page-header');
      pageDiv.appendChild(headerDiv);
      rootElement.appendChild(pageDiv);
      return pageDiv;
    };

    const createMapPage = () => {
      const mapPage = createNewPage();
      const mapDiv = document.createElement('div');
      mapDiv.id = 'map';
      mapDiv.style.height = '1000px';
      mapPage.appendChild(mapDiv);

      const mapboxScript = iframeDoc.createElement('script');
      mapboxScript.src = 'https://api.mapbox.com/mapbox-gl-js/v2.10.0/mapbox-gl.js';
      mapboxScript.onload = () => {
        const mapInitScript = iframeDoc.createElement('script');
        mapInitScript.type = 'text/javascript';
        mapInitScript.text = mapScript(searchTags, boundingBoxCoord);
        iframeDoc.body.appendChild(mapInitScript);
      };
      iframeDoc.head.appendChild(mapboxScript);
    };

   
    const insertFooter = (pageDiv) => {
      const footerDiv = document.createElement('div');
      footerDiv.innerHTML = ReactDOMServer.renderToString(footerHTML);
      footerDiv.classList.add('export-page-footer');
      pageDiv.appendChild(footerDiv);
    };
    const insertPageBreaks = () => {
      const contents = Array.from(iframeDoc.querySelectorAll('.page-section'));
      let accumulatedHeight = 0;
      let currentPageDiv = createNewPage();
    
      contents.forEach((content, index) => {
        const contentHeight = content.offsetHeight;
        accumulatedHeight += contentHeight;
    
        // Check if adding this content will cause overflow
        if (accumulatedHeight > (A4_HEIGHT_PX - HEADER_HEIGHT_PX - FOOTER_HEIGHT_PX) && index > 0) {
          // Check if the last element in the current page is a .header
          const lastElement = currentPageDiv.lastElementChild;
          if (lastElement && lastElement.classList.contains('header')) {
            // Move the last .header element to the next page
            currentPageDiv.removeChild(lastElement);
    
            // Insert footer before closing the current page
            insertFooter(currentPageDiv);
    
            // Create new page and add the .header to it
            currentPageDiv = createNewPage();
            currentPageDiv.appendChild(lastElement);
    
            // Reset accumulatedHeight for the new page
            accumulatedHeight = contentHeight;
          } else {
            // Insert footer before creating the new page
            insertFooter(currentPageDiv);
    
            // Create a new page
            accumulatedHeight = contentHeight;
            currentPageDiv = createNewPage();
          }
        }
    
        // Append the current content to the current page
        currentPageDiv.appendChild(content);
      });
    
      // Insert footer on the last page
      insertFooter(currentPageDiv);
    
      // formValuesCheckboxes.includes("showSnapshotMap") && createMapPage();
    };

    const replaceHeaders = () => {
      const headerSections = iframeDoc.querySelectorAll('.header-section');
      headerSections.forEach(headerSection => {
        headerSection.innerHTML = ReactDOMServer.renderToString(headerHTML);
      });
    };

    const replaceFooters = () => {
      const footerSections = iframeDoc.querySelectorAll('.footer-section');
      footerSections.forEach(footerSection => {
        footerSection.innerHTML = ReactDOMServer.renderToString(footerHTML);
      });
    };
  


    const renderContent = () => {
      
      iframeDoc.open();
      iframeDoc.write(`
        <html>
          <head>
            <link href="https://api.mapbox.com/mapbox-gl-js/v2.10.0/mapbox-gl.css" rel="stylesheet" />
            ${headerContent}
            <style>
              body { margin: 0; overflow: hidden; }
              #root { overflow: hidden; }
              .page-break {
                page-break-before: always;
              }
              .mapboxgl-map{
                min-width:1080px;
                width:100%;
              }
              .export-page {
                break-after: page;
                height: ${(A4_HEIGHT_PX+HEADER_HEIGHT_PX+FOOTER_HEIGHT_PX)}px;
                border-bottom: 20px solid #f5f7fa;
                position: relative;
                padding-bottom: ${FOOTER_HEIGHT_PX}px;
                background: #FFF;
                padding:20px;
              }
              .export-page-header {
                height: ${HEADER_HEIGHT_PX}px;
                margin-bottom: 20px;
              }
              .export-page-footer {
                height: ${FOOTER_HEIGHT_PX}px;
                margin-top: 20px;
                bottom: 0;
                width: 100%;
                padding: 10px 25px;
                text-align:center;
              }
              @media print {
                .export-page {
                  border-bottom: none;
                }
                .recharts-responsive-container{
                  max-width:1020px;
                }
                .mapboxgl-map{
                  min-width:1080px;
                  width:100%;
                }
                .delete-page-btn { display: none !important; }
              }
              .delete-page-btn {
                position: absolute;
                top: 10px;
                right: 10px;
                z-index: 10;
                width: 32px;
                height: 32px;
                border-radius: 50%;
                border: none;
                background: rgba(220, 53, 69, 0.92);
                color: #fff;
                cursor: pointer;
                display: none;
                align-items: center;
                justify-content: center;
                box-shadow: 0 1px 4px rgba(0,0,0,0.2);
              }
              .delete-page-btn:hover { background: #b02a37; }
              body.edit-mode .delete-page-btn { display: flex; }
            </style>
          </head>
          <body>
            <div id="root" class="${user && user.role && Array.isArray(user.role) ? user.role.map(r => "role-"+r).join(" ") : ""}"></div>
          </body>
        </html>
      `);
      iframeDoc.close();
      rootElement = iframeDoc.getElementById('root');
      
      if (!rootElement) {
        console.error("Root element not found in the iframe.");
        return;
      }
      rootElement.innerHTML = "";
      if (contentHTML == null) {
        // Modal has been closed; skip render to avoid null.$$typeof crash.
        return;
      }
      const isReactComponent = typeof contentHTML === 'object' && contentHTML.$$typeof;
      if (isReactComponent) {
        ReactDOM.render(contentHTML, rootElement, () => {
          insertPageBreaks();
          adjustIframeHeight();
          toggleEditMode(isEditMode); // Apply edit mode after rendering
          injectDeletePageButtons();
        });
      } else {
        ReactDOM.render(<div dangerouslySetInnerHTML={{ __html: contentHTML }} />, rootElement, () => {
          replaceHeaders();
          replaceFooters();
          adjustIframeHeight();
          toggleEditMode(isEditMode); // Apply edit mode after rendering
          injectDeletePageButtons();
        });
      }
    };

    const saveEdits = () => {
      const editedContent = iframeDoc.getElementById('root').innerHTML;
      onSaveChanges(editedContent); // Send the updated content to the parent component
    };

    const handleBlur = (event) => {
      if (event.target.classList.contains('editable')) {
        saveEdits(); // Save edits when an editable element loses focus
      }
    };

    const toggleEditMode = (enableEditMode) => {
      if (iframeDoc.body) {
        iframeDoc.body.classList.toggle("edit-mode", !!enableEditMode);
      }
      iframeDoc.querySelectorAll(".editable").forEach((element) => {
        if (enableEditMode) {
          element.setAttribute("contentEditable", "true"); // Enable editing
          element.addEventListener("blur", handleBlur);    // Listen for blur event
        } else {
          element.removeAttribute("contentEditable");      // Disable editing
          element.removeEventListener("blur", handleBlur); // Remove blur listener
        }
      });
    };

    const injectDeletePageButtons = () => {
      if (!onRequestPageDelete) return;
      const pages = iframeDoc.querySelectorAll(".export-page");
      pages.forEach((page) => {
        if (page.querySelector(".delete-page-btn")) return;
        const computed = iframeDoc.defaultView.getComputedStyle(page);
        if (computed.position === "static") {
          page.style.position = "relative";
        }
        const btn = iframeDoc.createElement("button");
        btn.type = "button";
        btn.className = "delete-page-btn print-hide";
        btn.setAttribute("aria-label", "Delete page");
        btn.setAttribute("title", "Delete page");
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/></svg>';
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const allPages = Array.from(iframeDoc.querySelectorAll(".export-page"));
          const currentIndex = allPages.indexOf(page);
          onRequestPageDelete(currentIndex);
        });
        page.appendChild(btn);
      });
    };
    
    renderContent();
    

    window.addEventListener('resize', adjustIframeHeight);

    return () => {
      window.removeEventListener('resize', adjustIframeHeight);
    };
  }, [contentHTML, headerHTML, footerHTML, searchTags, isMapLoaded, reportLoaded, isEditMode, onSaveChanges, preview]);

  return (
    <iframe ref={ref} scrolling="no" style={{ width: '100%', border: 'none', overflow: 'hidden', background: '#FFF', minHeight: `${A4_HEIGHT_PX}px` }} />
  );
});

const areEqual = (prevProps, nextProps) => {
  return prevProps.preview === nextProps.preview 
  && prevProps.isEditMode === nextProps.isEditMode 
  && prevProps.aiRun===nextProps.aiRun 

};

export default React.memo(ExportView, areEqual);
